// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__2BUOX","insightsList":"newBusinessInsightsMenu_insightsList__26-1h","active":"newBusinessInsightsMenu_active__1uEbK"};